import {useSpiderfier} from "../../../../../hooks/use-spiderfier.js";
import {useEffect} from "react";

const API_URL = import.meta.env.VITE_API_URL;

const mapMarkers = new Map();

export const useMarkers = ({
        map,
        markerLib,
        coreLib,
        pointsRef,
        setPointSelected,
        setShowPointPanel,
        initialData,
        pointSelected
    }) => {

    const oms = useSpiderfier(map, mapMarkers);

    useEffect(() => {
        if (map) map.addListener("click", () => oms.unspiderfy())
    }, [map]);

    const createMarker = ({id, position, icon, editing = true, draggable = true, name = ""}) => {
        const marker = new markerLib.Marker({
            position: new coreLib.LatLng(position.lat, position.lng),
            icon: `${API_URL}/public/assets/img/markers/customLayers/${editing ? "editing" : "normal"}/${icon}`,
            map,
            draggable,
            zIndex: 10,
            id,
        });

        oms.addMarker(marker);

        marker.addListener("click", () => {
            oms.spiderfy(id, () => {
                const point = pointsRef.current.find(p => p.id === id);
                setMarkerEditing(point, true)
                setPointSelected(point);
                setShowPointPanel(true);

                marker.setZIndex(99);
            });
        });

        marker.addListener("dragend", ({latLng}) => {
            marker.setPosition(latLng)
            mapMarkers.set(id, marker)
            oms.addMarker(marker);
        })

        marker.addListener("rightclick", () => {
            new google.maps.InfoWindow({
                content: `
                  <a target="_blank"
                     href="https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${marker.getPosition().lat()},${marker.getPosition().lng()}">
                     Abrir no Street View
                  </a>
                `,
            }).open(map, marker);
        });

        mapMarkers.set(id, marker);

        return {id, marker, data: {...initialData, name}}
    }

    const setMarkerEditing = (point, editing) => {
        if (!point?.marker) return;

        pointsRef.current.map(p => {
            p.marker.setIcon(point.marker.icon.replace("/editing/", "/normal/"))
        })

        point.marker.setIcon(
            point.marker.icon.replace( editing ? "/normal/" : "/editing/", editing ? "/editing/" : "/normal/")
        );
    }

    const updateIcon = (newIcon) => {
        pointsRef.current.map(p => {
            const isEditing = pointSelected && pointSelected.id === p.id
            p.marker.setIcon(`${API_URL}/public/assets/img/markers/customLayers/${isEditing ? "editing" : "normal"}/${newIcon.marker}`)
        })
    }

    const removeMarker = (markerId) => {
        if (mapMarkers.get(markerId)) mapMarkers.get(markerId).setMap(null);
    }

    return { createMarker, setMarkerEditing, updateIcon, removeMarker }
}
